import z from 'zod';

export const DetectLanguageSchema = z.object({
  language: z.string(),
});
